import { render, staticRenderFns } from "./preTemplate.vue?vue&type=template&id=3bc3627e"
import script from "./preTemplate.vue?vue&type=script&lang=js"
export * from "./preTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports